import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProjectService } from "../Services/ProjectService";
import Loader from "../global/Loader";
import Swal from "sweetalert2";
import { Table, Button, Empty } from "antd";

export default function ProjectTable({ projectAreas, projectType }) {
  const { i18n } = useTranslation();
  const projectService = useMemo(() => new ProjectService(), []);
  const [tblData, setTblData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [lang, setLang] = useState(
    localStorage.getItem("language") === "en" ? 2 : 1
  );
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    setLang(i18n.language === "en" ? 2 : 1);
  }, [i18n.language]);

  useEffect(() => {
    const fetchProjectList = async () => {
      setLoading(true);
      try {
        const res = await projectService.GetProjectListPublic(
          projectAreas,
          projectType,
          lang
        );

        const data = res.data.table.map((item, index) => ({
          key: index + 1,
          title: item.title,
          tenure: item.tenure,
          investigator: item.investigator,
          docEn: {
            DocUniqueId: item.enDocUniqueId,
            DocMimeType: item.enDocMimeType,
          },
          docHi: {
            DocMimeType: item.hiDocMimeType,
            DocUniqueId: item.hiDocUniqueId,
          },
        }));

        setTblData(data);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong while fetching the project list!",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProjectList();
  }, [lang, projectAreas, projectType, projectService]);

  const viewDoc = async (doc) => {
    setPageLoading(true);
    try {
      if (doc.DocUniqueId) {
        const res = await projectService.ViewDocument(doc.DocUniqueId);
        if (res.status === 200) {
          const fileBlob = new Blob([res.data], {
            type: doc.DocMimeType,
          });
          const dataUrl = window.URL.createObjectURL(fileBlob);
          window.open(dataUrl, "_blank");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Document not available.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error fetching document!",
      });
    } finally {
      setPageLoading(false);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      align: "center",
      width: 60,
      render: (text) => <span className="fw-bold">{text}</span>,
    },
    {
      title:
        <div style={{ textAlign: "center", width: "100%" }}>
      {lang === 2 ? "Project Details" : "परियोजना विवरण"}
    </div>,
          
      render: (row) => (
        <div className="project-card">
          <div className="title">{row.title}</div>

          <div className="info">
            <span>
              <b>
                {lang === 2
                  ? "Principal Investigator:"
                  : "प्रधान अन्वेषक:"}
              </b>{" "}
              {row.investigator}
            </span>
          </div>

          <div className="info">
            <span>
              <b>
                {lang === 2
                  ? "Tenure of the Project:"
                  : "परियोजना की अवधि:"}
              </b>{" "}
              {row.tenure}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: lang === 2 ? "View Details" : "विवरण देखें",
      align: "center",
      width: 150,
      render: (row) => (
        <Button
          type="primary"
          size="small"
          onClick={() =>
            viewDoc(lang === 2 ? row.docEn : row.docHi)
          }
          className="view-btn"
        >
          {lang === 2 ? "View" : "देखें"}
        </Button>
      ),
    },
  ];

  return (
    <div className="table-wrapper table-responsive-md">
      {pageLoading && <Loader />}

      <Table
        columns={columns}
        dataSource={tblData}
        loading={loading}
        bordered
        pagination={{
          pageSize,
          showSizeChanger: true,
          onShowSizeChange: (c, size) => setPageSize(size),
          pageSizeOptions: ["5", "10", "20", "50"],
        }}
        locale={{
          emptyText: (
            <Empty
              description={
                lang === 1
                  ? "कोई डेटा उपलब्ध नहीं है"
                  : "No Data Available"
              }
            />
          ),
        }}
      />
    </div>
  );
}